module.exports = __webpack_public_path__ + "static/img/logo-horizontal.cb6ba783.png";